import getColorFromVariables from './get-color-from-variables';
import getSafeColorScheme from './get-safe-color-scheme';

const getColorFromSurfaceVariables = (surfaceAttribute, variableName, variables) => {
  const surfaceId = getSafeColorScheme(surfaceAttribute, variables);

  return getColorFromVariables(variableName, {
    ...variables.root,
    ...variables.schemes[surfaceId],
  });
};

export default getColorFromSurfaceVariables;
